import { ColumnDef } from "@tanstack/react-table";

import { createColumns } from "@/helpers/tableHelper";
import { GetUserGroupsData } from "@/types/groups";

import { BADGE_LABEL_STATUS_MAP, BADGE_VARIANT_STATUS_MAP } from "./data";

type ColumnsProps = {
  handleShowViewGroupPanel?: (data: GetUserGroupsData) => void;
  handleShowEditGroupPanel?: (data: GetUserGroupsData) => void;
  handleShowDeleteModal?: (data: GetUserGroupsData) => void;
  editPermission?: boolean;
  deletePermission?: boolean;
  timezone?: {
    code: string;
    name: string;
  };
};

export const columns = ({
  handleShowViewGroupPanel,
  handleShowEditGroupPanel,
  handleShowDeleteModal,
  timezone,
  editPermission = false,
  deletePermission = false
}: ColumnsProps): ColumnDef<GetUserGroupsData, string>[] => {
  const { textColumn, dateColumn, statusColumn, actionColumn } =
    createColumns<GetUserGroupsData>(
      {
        statusMappings: {
          variant: BADGE_VARIANT_STATUS_MAP,
          label: BADGE_LABEL_STATUS_MAP
        },
        handleViewAction: handleShowViewGroupPanel,
        handleEditAction: handleShowEditGroupPanel,
        handleDeleteAction: handleShowDeleteModal,
        editPermission,
        deletePermission
      },
      timezone
    );

  return [
    textColumn({ key: "name", title: "Group name", maxSize: 200 }),
    textColumn({ key: "description", title: "Description", maxSize: 200 }),
    textColumn({ key: "module_count", title: "Modules", maxSize: 200 }),
    textColumn({ key: "user_count", title: "Assigned users", maxSize: 200 }),
    dateColumn({ key: "created_at", title: "Created at", timezone }),
    textColumn({ key: "created_by", title: "Created by", maxSize: 200 }),
    dateColumn({ key: "updated_at", title: "Modified at", timezone }),
    textColumn({ key: "updated_by", title: "Modified by", maxSize: 200 }),
    statusColumn({ maxSize: 200 }),
    actionColumn({ maxSize: 62 })
  ];
};
